import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { Inbox } from '@/features/emails/inbox'

const inboxSearchSchema = z.object({
  source: z.enum(['gmail', 'smartlead']).optional(),
})

export const Route = createFileRoute('/_authenticated/emails/inbox')({
  validateSearch: inboxSearchSchema,
  component: Inbox,
})
